
import {createSlice} from "@reduxjs/toolkit";

export const contractDrilldownSliceCDP = createSlice({
    name: 'contractDrilldownSlcCDP',
    initialState: {value: {id: 1, dataPointId: 0, dataType: null, filterId: null,


    }},
    reducers:
{
    changeContractDrilldownCDP: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeContractDrilldownCDP } = contractDrilldownSliceCDP.actions;

export default  contractDrilldownSliceCDP.reducer ;
